











































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import {SERVER_HOST_QR} from '@/config';
import IOpen from '@/components/icons/IOpen.vue'
import IEdit from '@/components/icons/IEdit.vue'
import ITrash from '@/components/icons/ITrash.vue'
import IPlay from '@/components/icons/IPlay.vue'
import IPause from '@/components/icons/IPause.vue'
import IVolume from '@/components/icons/IVolume.vue'
import IKebab from '@/components/icons/IKebab.vue'
import Modal from '@/components/UI/Modal.vue'

//import WaveSurfer from "wavesurfer.js";
//import AudioVisual from 'vue-audio-visual'

const dialog = namespace('dialog')
const forms = namespace('forms')
const newshards = namespace('newshards')

@Component({
  components: {
    'i-open': IOpen,
    'i-trash': ITrash,
    Modal,
    'i-play': IPlay,
    'i-pause': IPause,
    'i-edit': IEdit,
    'i-volume': IVolume,
    'i-kebab': IKebab,
  }
})
export default class MediaAttachments extends Vue {
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions:any
  @newshards.Action('deleteMediaAttachmentFromServer') protected deleteMediaAttachmentFromServer:any

  @Prop({type: [Object], default: {}}) protected shard!: any
  @Prop({type: [Boolean], default: false}) protected loadShardStatus!: boolean

  editNoteDlgState:boolean = false
  currentNote:any = {}
  openModal:boolean = false
  loading:boolean = true
  leftHeight:any = 0
  rightHeight:any = 0
  height:any = {
    left: 0,
    right: 0
  }
  wavesurfers:any = {}
  currentTime:string = '0:00'
  baseURL:string = SERVER_HOST_QR

  beforeMount() {
    this.shard.mediaAttachments.forEach((note:any) => {
      if(note.type == 'voice') {
        note.duration = this.getDuration(note.audioDuration)
        note.currentTime = '0:00'
      }
    })
  }

  mounted() {
    setTimeout(() => {
      this.position()
    }, 100)
    window.onresize = () => {
      this.position()
    }
  }

  @Watch('shard')
  shardLoad(shard:any) {
    this.shard.mediaAttachments.forEach((note:any) => {
      if(note.type == 'voice') {
        note.duration = this.getDuration(note.audioDuration)
        note.currentTime = '0:00'
      }
    })
    setTimeout(() => {
      this.position()
    }, 100)
  }

  destroyed() {
    window.onresize = () => {
      this.position()
    }
    window.removeEventListener('onresize', () => {
      this.position()
    })
  }

  position() {
    let notes = this.$refs.notes as HTMLElement
    if(this.shard.mediaAttachments.length) {
      if(window.innerWidth > 1264) {
        let leftHeight = 0
        let rightHeight = 0
        for(let i = 0; i < this.shard.mediaAttachments.length; i++) {
          let elem = (this.$refs['note' + i] as HTMLElement[])[0]
          let type = this.shard.mediaAttachments[i].type
          let text = this.shard.mediaAttachments[i].text
          let height = 15
          if(type == 'voice') {
            height += text.length ? 94 : 60
          } else if (type == 'photo' || type == 'sketch') {
            height += elem.clientWidth * 0.6 
            height += text.length ? 79 : 0
          } else if (type == 'note') {
            height += 64
          }
          /*if(this.shard.mediaAttachments[i].type == 'voice') {
            let xhr = { cache: 'default', mode: 'no-cors', method: 'GET', credentials: 'same-origin', redirect: 'follow', referrer: 'client', headers: [ { key: 'Authorization', value: "Bearer " + localStorage.getItem('access-token') } ]};

            let elem = WaveSurfer.create({
              container: "#wave" + this.shard.mediaAttachments[i].id,
              height: 40,
              waveColor: "#8EC6E7",
              progressColor: "#2D9CDB",
              cursorWidth: 0,
              xhr:xhr
            });


            elem.load('https://stage.lfs.rest/api/v4/media?key=' + this.shard.mediaAttachments[i].fileKey + '&bucket=media');
            this.wavesurfers[this.shard.mediaAttachments[i].id] = elem;
          }*/
          if(i == 0) {
            leftHeight += height
            elem.style.top = '0'
            elem.style.left = '0'
          } else if (i == 1) {
            rightHeight += height
            elem.style.top = '0'
            elem.style.right = '0'
          } else {
            if(rightHeight >= leftHeight) {
              elem.style.left = '0'
              elem.style.right = 'auto'
              elem.style.top = leftHeight + 'px'
              leftHeight += height
            }else {
              elem.style.right = '0'
              elem.style.left = 'auto'
              elem.style.top = rightHeight + 'px'
              rightHeight += height
            }
          }
        }
        notes.style.height = rightHeight > leftHeight ? rightHeight + 'px' : leftHeight + 'px'
      }
    } else {
      notes.style.height = '35px'
    }
  }

  /*getDuration(note:any) {
    let audio = (document.getElementById(note.id) as HTMLElement)
    
    let minutes = (audio.duration / 60)
    let index = minutes.toString().indexOf('.')
    minutes = minutes.toString().slice(0,index)
    let seconds = (audio.duration % 60)
    index = seconds.toString().indexOf('.')
    seconds = seconds.toString().slice(0,index)
    let currentSeconds = ('0' + seconds).slice(-2)

    let time = `${minutes}:${currentSeconds}`

    return `${minutes}:${currentSeconds}`
  }*/

  getDuration(duration:any) {
    let minutes:any = (duration / 60)
    let index:any = minutes.toString().indexOf('.')
    minutes = index == -1 ? minutes : minutes.toString().slice(0,index)
    let seconds:any = (duration % 60)
    index = seconds.toString().indexOf('.')
    seconds = index == -1 ? seconds : seconds.toString().slice(0,index)
    let currentSeconds:any = ('0' + seconds).slice(-2)

    return `${minutes}:${currentSeconds}`
  }

  play(note:any) {
    this.shard.mediaAttachments.map((media:any) => {
      if(media.type == 'voice') media.play = false
    })
    let audio = (document.getElementById(note.id) as HTMLVideoElement)
    let timeline = (audio.closest('.lfs-shards-note-voice-wave')!.querySelector('.lfs-audio-timeline') as HTMLElement)
    audio.play()
    note.play = true
    audio.ontimeupdate = () => {
      this.changeTimeline(timeline, audio, note)
    } 
    audio.onended = () => {
      note.play = false
      note.currentTime = note.duration
      this.currentTime = '0:00'
    }
  }

  pause(note:any) {
    let audio = (document.getElementById(note.id) as HTMLVideoElement)
    audio.pause()
    note.play = false
    note.currentTime = this.currentTime
  }

  changeTimeline(timeline:any, audio:any, note:any) {
    const percentagePosition = (100*audio.currentTime) / audio.duration;
    timeline.style.backgroundSize = `${percentagePosition}% 100%`
    timeline.value = percentagePosition
    let currentTime = ''
    this.currentTime = this.getDuration(audio.currentTime)
  }

  changeSeek(note:any) {
    let audio = (document.getElementById(note.id) as HTMLVideoElement)
    let timeline:any = (audio.closest('.lfs-shards-note-voice-wave')!.querySelector('.lfs-audio-timeline') as HTMLInputElement)
    let time:any = (timeline.value * audio.duration) / 100;
    audio.currentTime = time;
  }

  changeVolume(note:any) {
    let audio = (document.getElementById(note.id) as HTMLVideoElement)
    if(audio.volume == 0) {
      audio.volume = 1
      note.mute = false
    } else {
      audio.volume = 0
      note.mute = true
    }
  }

  getHeight(note:any) {
    if(note.type == 'voice') {
      return note.text.length ? 154 : 136
    } else if (note.type == 'photo' || note.type == 'sketch') {
      return note.text.length ? 290 : 272
    } else if (note.type == 'text') {
      return 120
    }
  }

  deleteNote() {
    this.deleteMediaAttachmentFromServer(this.currentNote.id)
    this.openModal = false
    this.position()
  }

  editNoteDlgClose() {
    this.editNoteDlgState = false
  }

  /*play(note:any) {
    console.log(this.$refs.wave62b2f0fa4d035c1ecd44e4c4)
    if(note.play) {
      this.wavesurfers[note.id].pause();
      note.play = false
    } else {
      for(let key in this.wavesurfers) {
        this.wavesurfers[key].pause()
      }
      this.shard.mediaAttachments.forEach((media:any) => {
        if(media.type == 'voice') {
          media.play = false
        }
      })
      this.wavesurfers[note.id].play();
      note.play = true
      this.$refs.wave62b2f0fa4d035c1ecd44e4c4.play()
    }
  }*/

  openDelete(note:any) {
    this.currentNote = note
    this.openModal = true
  }

  openEditDlg(note:any) {
    this.SetTitleDialog(this.$t('newShardList.mediaAttachments.title'))
    this.SetFormSDialog('NoteEditForm')
    this.SetFullDialogShow(true)
    this.setOptions({
      note: {...note}
    })
  }

  saveNote() {
    this.editNoteDlgState = false
  }
}
